import React from 'react'
import useExpendienteReportesEnviadosPorCorreo from '../hooks/adminexamen/useExpendienteReportesEnviadosPorCorreo';
import { List, Typography } from 'antd'
import { carreras } from '../data/datos';
import { Toaster } from 'react-hot-toast';


const { Link } = Typography;

const ExpedienteReportesEnviadosPorCorreo = () => {

    const { expedienteTodosReportesEnviados } = useExpendienteReportesEnviadosPorCorreo();

    return (
        <>
            <List
                header={<div className='ta-center'>Seleccione una carrera para generar expediente</div>}
                bordered
                dataSource={carreras}
                renderItem={item => {
                    return (
                      <List.Item>
                        <Link
                          className="link-carrera"
                          onClick={() =>
                            expedienteTodosReportesEnviados(
                                item.id,
                                item.nom_carrera
                            )
                          }
                        >
                          {item.nom_carrera}
                        </Link>
                      </List.Item>
                    );
                }}
            />
            <Toaster/>
        </>
    )
}

export default ExpedienteReportesEnviadosPorCorreo;
